export default "__VITE_ASSET__dVsD2gmo__"